module.exports = __webpack_public_path__ + "img/play-circled-white.53c2b736.svg";